var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rect',{style:(_vm.glyphStyle),attrs:{"height":_vm.size,"width":_vm.size,"transform":_vm.transformAttribute}},[(_vm.showLabel)?_c('title',{staticStyle:{"text-align":"left"}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","from":"0 0","to":"1 1","begin":"0s","dur":"1s"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }